(function(){
    'use strict'

    angular.module('app.cantidadesDestajo')
    .factory('CantidadesDestajoService', CantidadesDestajoService);

    CantidadesDestajoService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function CantidadesDestajoService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getSiguienteCorte: getSiguienteCorte,
            getById: getById,
            save: save,
            update:update,
            remove: remove
        };

        return api;

        function getAll(searchCriteria){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/cantidades-destajo/search',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        };

        function getById(cantidadDestajoId){

            var url = apiSettings.apiBaseUrl + 'api/cantidades-destajo/' + cantidadDestajoId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function getSiguienteCorte(companiaId, calendarizacionId, cantidadId, fecha){

            var url = apiSettings.apiBaseUrl + 'api/cantidades-destajo/siguiente-corte/' + companiaId + '/' + calendarizacionId + '/' + cantidadId + '/' + fecha;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(cantidadDestajo){

            cantidadDestajo.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/cantidades-destajo',  
                method: 'POST',  
                data: cantidadDestajo
            });  
            return response;
        };

        function update(cantidadDestajo){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/cantidades-destajo',  
                method: 'PUT',  
                data: cantidadDestajo
            });  
            return response;
        };

        function remove(cantidadDestajo){

            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/cantidades-destajo',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: cantidadDestajo
            });  
            return response;
        };

    };

})();